export default "__VITE_ASSET__17bee46e__"